import React, {useEffect} from "react";
import styles from "./MaintenancePage.module.scss";
import InitialContainer from "@/components/Global/InitialContainer/InitialContainer";
import Box from "@/components/Global/Box/Box";
import {config} from "@/config";
import {clearCache} from "@/helpers/clearCache.js";

const {websiteId} = config;

export default function MaintenancePage() {
  const isForth = websiteId === 1;
  const isEdge = websiteId === 2;

  useEffect(() => {
    if (isForth) {
      document.documentElement.setAttribute("data-theme", "forth");
      document.documentElement.setAttribute("data-variant", "light");
      document.documentElement.setAttribute("data-bs-theme", "light");
    } else if (isEdge) {
      document.documentElement.setAttribute("data-theme", "edge");
      document.documentElement.setAttribute("data-variant", "dark");
      document.documentElement.setAttribute("data-bs-theme", "dark");
    } else {
      document.documentElement.setAttribute("data-theme", "custom");
      document.documentElement.setAttribute("data-variant", "light");
      document.documentElement.setAttribute("data-bs-theme", "light");
    }

    clearCache({forceRefresh: false});
  }, []);

  return (
    <InitialContainer isForth={isForth}>
      <main className="my-5 pt-5 d-flex flex-column h-100">
        <div className="row my-auto justify-content-center align-items-center">
          <div className="col-12 text-center">
            <Box className={`${styles.box} ${isForth ? styles.light : styles.dark}`}>
              <span aria-hidden className={`${styles.icon} d-block mb-3`}>
                🚧
              </span>
              <h1>We'll be back soon!</h1>
              <p className="text-pretty lh-base">
                Our app is currently undergoing scheduled maintenance. We should be back shortly
              </p>
              <h4>Thank you for your patience</h4>
            </Box>
          </div>
        </div>
      </main>
    </InitialContainer>
  );
}
